/**
 * InfinitSales - marca do topo da lista de conversas (os 5 inboxes).
 *
 * Fora do modo embutido é a marca da InfinitSales, como sempre. No CRM
 * embutido em painel parceiro (white label, 2026-10-22) mostra a marca do
 * WORKSPACE (nome e logo do campo `white_label`); sem logo cadastrado, só o
 * nome. Antes o mesmo bloco estava copiado nos shells do QR, do Business e
 * no compartilhado (Instagram, Messenger, widget).
 */
import React from 'react';
import { getEmbedBranding, isEmbedded } from '../../utils/embed';

export function brandName() {
  if (!isEmbedded()) return 'InfinitSales';
  return getEmbedBranding()?.name || '';
}

const InboxBrand = ({ logoStyle, textStyle }) => {
  const embutido = isEmbedded();
  const logo = embutido ? getEmbedBranding()?.logo_url : `${process.env.PUBLIC_URL}/logo.jpeg`;
  const nome = brandName();
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
      {logo && (
        <span style={logoStyle}>
          <img src={logo} alt={nome || 'Marca'} style={{ width: 20, height: 20, objectFit: 'contain' }} />
        </span>
      )}
      {nome && <span style={textStyle}>{nome}</span>}
    </div>
  );
};

export default InboxBrand;
